"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lisciano-niccone": {
    "f55d8583": [{
      "hkey": "6fe08894",
      "slug": "crocicchie",
      "name": "Crocicchie",
      "primary": true,
      "skipSearch": false
    }],
    "crocicchia": [{
      "hkey": "6fe08894",
      "slug": "crocicchie",
      "name": "Crocicchie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d0291486": [{
      "hkey": "03d4b53d",
      "slug": "lisciano-niccone",
      "name": "Lisciano Niccone",
      "primary": true,
      "skipSearch": false
    }],
    "reschio": [{
      "hkey": "03d4b53d",
      "slug": "lisciano-niccone",
      "name": "Lisciano Niccone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e93364d1": [{
      "hkey": "03d4b53d",
      "slug": "lisciano-niccone",
      "name": "Lisciano Niccone",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "03d4b53d",
      "slug": "lisciano-niccone",
      "name": "Lisciano Niccone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e005dc8": [{
      "hkey": "03d4b53d",
      "slug": "lisciano-niccone",
      "name": "Lisciano Niccone",
      "primary": true,
      "skipSearch": false
    }],
    "val-di-rose": [{
      "hkey": "03d4b53d",
      "slug": "lisciano-niccone",
      "name": "Lisciano Niccone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;